import PaymentOutputCardView from './PaymentOutputCardView.html';
import { ValueSource } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/Condition';
import { PAYMENT_GENERATE_COMPONENT } from 'modules/application/detail/portal-submodule-builder/templates/builder/payment/PaymentConstants';
import { PaymentStatus } from 'modules/application/detail/portal-submodule-builder/templates/builder/payment/state/Enums';
class PaymentOutputCard {
    static $inject = ['$translate', '$attrs'];
    constructor($translate, $attrs) {
        'ngInject';
        this.$translate = $translate;
        this.hasRemoveButton = $attrs.onRemove ? true : false;
    }
    $onInit() {
        this.availableStatus = [
            {
                value: PaymentStatus.Success,
                label: this.$translate.instant('builder-tabs-outputs.payment.success'),
            },
            {
                value: PaymentStatus.Error,
                label: this.$translate.instant('builder-tabs-outputs.payment.error'),
            },
        ];
        this.condition = this.output.conditions.find(c => c.source == ValueSource.Context && c.variable == PAYMENT_GENERATE_COMPONENT);
        const status = this.condition?.values[0];
        this.selectedStatus = this.availableStatus.find(s => s.value == status);
    }
    addNewState($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewState({ $data });
    }
    addNewSurvey($data) {
        $data.output = this.output;
        $data.state = this.state;
        this.onAddNewSurvey({ $data });
    }
    changeOutputState($data) {
        $data.output = this.output;
        this.outputChanged({ $data });
    }
    toggleInfo() {
        this.showInfo = !this.showInfo;
    }
}
export const PaymentOutputCardComponent = {
    controller: PaymentOutputCard,
    controllerAs: '$ctrl',
    template: PaymentOutputCardView,
    bindings: {
        output: '<',
        outputChanged: '&',
        states: '<',
        state: '<',
        application: '<',
        onRemove: '&',
        onAddNewState: '&?',
        onAddNewSurvey: '&?',
        showSwitchSurvey: '<',
    },
};
